// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--4yxWA";
export var faq = "styles-module--faq--BzHFz";
export var title = "styles-module--title--BIN70";
export var button = "styles-module--button--8+nk8";
export var item = "styles-module--item--vlwgE";
export var question = "styles-module--question--SR32x";